export interface FlightPriceAdjustmentInput {
  // Raw offer total across all travelers, e.g. fitm.price.total / a live re-quote's price.total
  totalPrice: number | string
  persons: number
  vendor: string
  // order_data's tripFlightInfo - the markup schedule (baseprice/diffprice/adjustprice tiers)
  tripFlightInfo?: {
    baseprice?: number | string
    adjustprice?: (number | string)[]
    diffprice?: (number | string)[]
    simplyPriceAdjust?: number | string
  } | null
  // order_data.cityprice - the product's base per-person airfare allowance
  cityPrice?: number | string
}

// Same math as flight/filter.vue's getFlightPrice(fitm), decoupled from the raw
// offer/localDriver so it can be reused wherever a fare total needs re-pricing
// against the same product/tripFlightInfo markup schedule (e.g. re-confirming a
// live price change without re-running the full flight search).
export function calcFlightOfferPrice({
  totalPrice,
  persons,
  vendor,
  tripFlightInfo,
  cityPrice
}: FlightPriceAdjustmentInput): string {
  const basePriceFromCity = parseFloat(String(cityPrice ?? 0)) || 0
  const total = parseFloat(String(totalPrice ?? 0)) || 0

  if (vendor == 'tba') {
    const finalTbaPrice = total - basePriceFromCity
    return finalTbaPrice <= 0 ? '0' : finalTbaPrice.toFixed(0)
  }

  let price = total / (persons || 1)
  if(vendor == 'simplifly'){
    const simplyPrice = price * (1.0+parseFloat(String(tripFlightInfo?.simplyPriceAdjust??'0'))) - basePriceFromCity
    return simplyPrice <= 0 ? '0' : simplyPrice.toFixed(0)
  }
  if (tripFlightInfo && Object.keys(tripFlightInfo).length > 0) {
    const basePrice = basePriceFromCity
    let diffprice = price - basePrice
    diffprice = diffprice > 0 ? diffprice : 0
    const adjustprice = tripFlightInfo.adjustprice ?? []
    let curAdjPrice = parseFloat(String(adjustprice[adjustprice.length - 1] ?? 0)) || 0
    const diffpriceTiers = tripFlightInfo.diffprice ?? []
    for (let i = 0; i < diffpriceTiers.length; i++) {
      if (diffprice < parseFloat(String(diffpriceTiers[i]))) {
        curAdjPrice = parseFloat(String(adjustprice[i] ?? 0)) || 0
        break
      }
    }
    price = price - basePrice + curAdjPrice
  }
  return price.toFixed(0)
}
